// extracted by mini-css-extract-plugin
export default {"cards-wrap":"styles__cards-wrap--hWKsB"};